<div class="message-sent">
  <div class="message-sent__icon">
    <ion-icon src="../../assets/icons/message-sent.svg"></ion-icon>
  </div>
  <div class="message-sent__header">
    {{ header | translate }}
  </div>
  <div class="message-sent__message">
    <div>
      {{ descriptionStart | translate }}:
    </div>
    <div  class="message-sent__mail">
      {{ userEmail }}
    </div>
    <div *ngIf="descriptionEnd">
      {{ descriptionEnd | translate }}
    </div>
  </div>
  <hr>
  <div class="message-sent__no-message-text">
    {{ 'EMAIL_MESSAGE_COMPONENT.NO_MESSAGE' | translate }}
  </div>
  <ion-fab
    class="message-sent__back"
  >
    <ion-fab-button
      href="/auth"
      size="small"
    >
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</div>
